import React from "react";
import { Heart, Users, Award, Clock } from "lucide-react";
import { useClinic } from "../context/ClinicContext";

const About = () => {
  const { clinicInfo } = useClinic();
  const features = [
    {
      icon: Heart,
      title: "Patient-Centered Care",
      description: "We believe in your overall oral health and well-being",
    },
    {
      icon: Users,
      title: "Experienced Team",
      description: "American Board Certified dentist with years of expertise",
    },
    {
      icon: Award,
      title: "Latest Technology",
      description:
        "Utilizing the most advanced dental techniques and equipment",
    },
    {
      icon: Clock,
      title: "Flexible Hours",
      description: "Open Sunday through Thursday for your convenience",
    },
  ];

  return (
    <section id="about" className="section-padding bg-[#F5F5F4]">
      <div className="container mx-auto px-8 lg:px-16">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Left - Images */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-6">
              <div className="space-y-6">
                <div className="overflow-hidden rounded-md shadow-refined group">
                  <img
                    src="https://images.unsplash.com/photo-1643660526741-094639fbe53a?w=400&q=80"
                    alt="Dental clinic interior"
                    className="w-full h-72 object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="overflow-hidden rounded-md shadow-refined group">
                  <img
                    src="https://images.unsplash.com/photo-1704455306251-b4634215d98f?w=400&q=80"
                    alt="Consultation area"
                    className="w-full h-56 object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
              </div>
              <div className="pt-16">
                <div className="overflow-hidden rounded-md shadow-refined group">
                  <img
                    src="https://images.unsplash.com/photo-1606811842243-af7e16970c1f?w=400&q=80"
                    alt="Dentist with patient"
                    className="w-full h-96 object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Right - Content */}
          <div className="space-y-10">
            <div className="space-y-6">
              <div className="divider-accent"></div>
              <h2 className="heading-1 text-[#1C1917]">
                Welcome to a Family Dental Clinic
              </h2>
              <p className="body-large text-[#57534E] leading-relaxed">
                Here at {clinicInfo.name} we believe in our overall patient oral
                health and well-being and guide you in making the best choices
                for your dental care.
              </p>
              <p className="body-regular text-[#78716C] leading-relaxed">
                We work together! Our ultimate goal is to provide you with a
                warm, inviting and comfortable environment in which to seek
                dental care as we understand your concerns about coming to see
                the dentist. You will be under the care of an American Board
                Certified dentist utilizing the latest in dental advancements.
              </p>
            </div>

            {/* Features Grid */}
            <div className="grid sm:grid-cols-2 gap-8 pt-6">
              {features.map((feature, index) => (
                <div key={index} className="space-y-3 group">
                  <div className="w-12 h-12 rounded-full bg-[#FAFAF9] flex items-center justify-center transition-all duration-300 group-hover:bg-[#0F766E]/10">
                    <feature.icon
                      className="w-6 h-6 text-[#0F766E]"
                      strokeWidth={1.5}
                    />
                  </div>
                  <h3 className="heading-3 text-[#1C1917]">{feature.title}</h3>
                  <p className="body-small text-[#78716C]">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
